import { page, pages } from '@store/App.store';
import { useState, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const usePage = () => {
    const location = useLocation();
    const [page, setPage] = useState<string>(pages.default);

    useLayoutEffect(() => {
        const path = location.pathname;
        const regExp = /[^\/]*/;
        const res = path.slice(1).match(regExp);
        if (res) {
            const [page] = res;
            setPage(page);
        }
    }, [location.pathname]);

    return page;
};
